exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".generate-label[data-v-588552de] {\n  display: inline;\n}\n.generate-label-btn[data-v-588552de],\n.generate-label-btn[data-v-588552de]:hover,\n.generate-label-btn[data-v-588552de]:focus {\n  background-color: #2b93ff !important;\n  margin-left: 0px;\n}\n.download-label[data-v-588552de] {\n  display: inline-block !important;\n}\n", ""]);

// exports
